module.exports = __webpack_public_path__ + "static/media/thumb-down.bda6ed23.svg";